<style>
  .lastDsc {
    background-color: #ff9c95 !important;
  }
  .customerIgnore {
    background-color: #d6ff95 !important;
  }
</style>

<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Letter Inbox</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> ID  </label>
          <input type="text" class="form-control" [(ngModel)]="Search_code_LetterRequestCustomerId"
            name="Search_code_LetterRequestCustomerId" placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> Letter Number </label>
          <input type="text" class="form-control" [(ngModel)]="Search_code_LetterRequestCustomer"
            name="Search_code_LetterRequestCustomer" placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> Letter Subject </label>
          <input type="text" class="form-control" [(ngModel)]="Search_persianDate_LetterRequestCustomer"
            name="Search_persianDate_LetterRequestCustomer" placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Customer Name </label>
          <input type="text" class="form-control" [(ngModel)]="Search_customer_LetterRequestCustomer"
            name="Search_customer_LetterRequestCustomer" placeholder="Type here to search...">
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Message </label>
          <select [(ngModel)]="Search_Order_LetterRequestCustomer" name="Search_Order_LetterRequestCustomer"
            class="custom-select">
            <option value="">All</option>
            <option *ngFor="let item of Search_Order_LetterRequestCustomer_List" [value]="item">{{item}}</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Status </label>
          <select [(ngModel)]="Search_Section_LetterRequestCustomer" name="Search_Section_LetterRequestCustomer"
            class="custom-select">
            <option value="">All</option>
            <option *ngFor="let item of Search_Section_LetterRequestCustomer_List" [value]="item">{{item}}</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Letter Type </label>
          <select [(ngModel)]="Search_Readed_LetterRequestCustomer" name="Search_Readed_LetterRequestCustomer"
            class="custom-select">
            <option value="">All</option>
            <option value="1">Read</option>
            <option value="2">New</option>
          </select>
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_LetterRequestCustomer()" class="btn btn-info"
            style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>

          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1" style="font-weight: bolder;">Letter Count : {{(DataList_LetterRequestCustomer
            |filter:Search_persianDate_LetterRequestCustomer:'subject_name'
            |filter:Search_code_LetterRequestCustomer:'code'
            |filter:Search_code_LetterRequestCustomerId:'letterCode'
            |filter:Search_customer_LetterRequestCustomer:'customer').length}} </label>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1" style="font-weight: bolder;">Unread Letter Count :
            {{(DataList_LetterRequestCustomer
            |filter:Search_persianDate_LetterRequestCustomer:'subject_name'
            |filter:Search_code_LetterRequestCustomer:'code'
            |filter:Search_code_LetterRequestCustomerId:'letterCode'
            |filter:'2':'readedId'
            |filter:Search_customer_LetterRequestCustomer:'customer').length}} </label>
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>ID</th>
              <th>Letter</th>
              <th>Type</th>
              <th>Customer</th>
              <th>Subject</th>
              <th>Sender</th>
              <th>Status</th>
              <th>Referral Date</th>
              <th>Attachment</th>
              <th>Message</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_LetterRequestCustomer
          |filter:Search_persianDate_LetterRequestCustomer:'subject_name'
          |filter:Search_customer_LetterRequestCustomer:'customer'
          |filter:Search_code_LetterRequestCustomer:'code'
          |filter:Search_code_LetterRequestCustomerId:'letterCode'
          |filter:Search_Readed_LetterRequestCustomer:'readedId'
          |filter:Search_Order_LetterRequestCustomer:'lastOrder'
          |filter:Search_Section_LetterRequestCustomer:'lastSection'
          | paginate
                  : {
                      id: 'DataList_FeildTable',
                      itemsPerPage: 10,
                      currentPage: page,
                      totalItems: (DataList_LetterRequestCustomer
                      |filter:Search_persianDate_LetterRequestCustomer:'subject_name'
                      |filter:Search_code_LetterRequestCustomer:'code'
                      |filter:Search_code_LetterRequestCustomerId:'letterCode'
                      |filter:Search_Readed_LetterRequestCustomer:'readedId'
                      |filter:Search_customer_LetterRequestCustomer:'customer'
                      |filter:Search_Section_LetterRequestCustomer:'lastSection'
                      |filter:Search_Order_LetterRequestCustomer:'lastOrder').length
                    }
          " [ngClass]="{'lastDsc': item.lastDsc,'customerIgnore': item['customerIgnore']}">
              <td>
                <p *ngIf="item.readed">{{DataList_LetterRequestCustomer.indexOf(item)+1}}</p>
                <span *ngIf="!item.readed" class="badge badge-pill badge-info float-right mt-1">New</span>
              </td>
              <td>{{item.letterCode}}</td>
              <td>{{item.code}}</td>
              <td>{{item.letterType === 'رسید امانت' ? 'Custody Receipt' : item.letterType === 'نامه وارده' ? 'Incoming Letter' : item.letterType === 'نامه صادره' ? 'Outgoing Letter' : item.letterType === 'درخواست کالیبراسیون' ? 'Calibration Request' : item.letterType}}</td>
              <td>{{item.customer}}</td>
              <td>{{item.subject_name}}</td>
              <td>{{item.lastSender}}</td>
              <td>{{item.lastSection}}</td>
              <td>{{item.lastDate}}</td>
              <td>
                <i *ngIf="item.peyvaset" class="fa fa-check" style="color: green;"></i>
                <i *ngIf="!item.peyvaset" class="fa fa-times" style="color: red;"></i>
                <i *ngIf="item.sms" class="fa fa-envelope" style="color: blue;"></i>
                <i *ngIf="item.codePeygiri" class="fa fa-money" title="{{item.codePeygiri}}" style="color: blue;"></i>

              </td>
              <td>{{item.lastOrder}}</td>
              <td>
                <a target="_blank" class="btn btn-info" *ngIf="item.letterType=='رسید امانت'"
                  [routerLink]="['/LetterRequestCustomerPreOrder',{id:item.id}]"><i class="fa fa-edit"></i> View
                </a>
                <a target="_blank" class="btn btn-info" *ngIf="item.letterType=='نامه وارده'"
                  [routerLink]="['/LetterRequestCustomerDraftForm',{id:item.id}]"><i class="fa fa-edit"></i>
                  View </a>
                <a target="_blank" class="btn btn-info" *ngIf="item.letterType=='نامه صادره'"
                  [routerLink]="['/LetterRequestCustomerForm',{id:item.id}]"><i class="fa fa-edit"></i> View
                </a>
                <a target="_blank" class="btn btn-info" *ngIf="item.letterType=='درخواست کالیبراسیون'"
                  [routerLink]="['/LetterRequestCustomerCalibration',{id:item.id}]"><i class="fa fa-edit"></i>
                  View </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>